import { useState } from "react";
import { ConfirmationModalProps } from "./modal.types";
import { ConfirmationModal } from "./ConfirmationModal";
import { ActionButtonProps } from "../buttons";
import { ActionButton } from "../buttons/ActionButton";
import { ModalTrigger } from "./ModalTrigger";

export type ConfirmationActionButtonProps = {
  confirmProps?: ConfirmationModalProps;
  confirm?: boolean;
} & ActionButtonProps;

/**
 * Functional Component: ConfirmationActionButton
 * 
 * This component renders an action button that can trigger a confirmation modal when clicked.
 * It uses the ModalTrigger component to manage the modal display and actions.
 * 
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {ConfirmationModalProps} [props.confirmProps] - Optional properties for configuring the confirmation modal.
 * @param {boolean} [props.confirm] - Optional flag to indicate if confirmation is required.
 * @param {any} props.onClickProps - Properties to be passed to the onClick handler of the action button.
 * @param {ActionButtonProps} restProps - Additional properties for the action button.
 * 
 * Returns:
 * @returns {JSX.Element} A JSX element containing the action button and the modal trigger.
 */
export const ConfirmationActionButton = (
  props: {
    confirmProps?: ConfirmationModalProps;
    confirm?: boolean;
    onClickProps: any;
  } & ActionButtonProps
) => {
  const { confirmProps, ...restProps } = props;
  const { onClose, show, actionToDispatch, ...rest } = confirmProps!;

  return (
    <div>
      <div className={"ebd-icon"}>
        <ModalTrigger
          trigger={{ ...restProps, Component: ActionButton }}
          modal={{
            ...rest,
            data: {
              onClickProps: props.onClickProps,
              actionToDispatch: props.actionToDispatch,
            },
            Component: ConfirmationModal,
          }}
        />
      </div>
    </div>
  );
};
